import {Component, Inject} from '@angular/core';
import {DialogResult, DialogResultType} from '../DialogResult';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs/internal/Observable';

export enum RecurringDodType {
  Weekly = 1,
  Monthly = 2
}

export class RecurringDodDialogData {
  dodRecurringId: number;
  dodBatchLayoutId: number;
  recurringType: RecurringDodType;
  dayOfWeek: number | undefined;
  dayOfMonth: number | undefined;
  emailOnly: boolean = false;
}

export class RecurringDodDialogResult {
  dodRecurringId: number;
  dodBatchLayoutId: number;
  recurringType: RecurringDodType;
  dayOfWeek: number | undefined;
  dayOfMonth: number | undefined;
}

@Component({
  selector: 'recurring-dod-dialog',
  templateUrl: './recurring-dod-dialog.component.html',
})
export class RecurringDodDialogComponent {

  results: RecurringDodDialogResult = {
    dodRecurringId: 0,
    dodBatchLayoutId: 0,
    recurringType: RecurringDodType.Weekly,
    dayOfWeek: 0,
    dayOfMonth: 1
  };

  constructor(
    public dialogRef: MatDialogRef<RecurringDodDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RecurringDodDialogData
  ) {

    this.results.dodRecurringId = data.dodRecurringId;
    this.results.dodBatchLayoutId = data.dodBatchLayoutId;
    this.results.recurringType = RecurringDodType.Weekly;
    this.results.dayOfWeek = data.dayOfWeek;
    this.results.dayOfMonth = data.dayOfMonth;

    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  public Result: DialogResult;

  static showDialog(
    dialog: MatDialog,
    dodRecurringId: number,
    dodBatchLayoutId: number,
    recurringType: RecurringDodType,
    dayOfWeek: number | undefined,
    dayOfMonth: number | undefined
  ): Observable<any> {
    const params: RecurringDodDialogData = {
      dodRecurringId,
      dodBatchLayoutId,
      recurringType,
      dayOfWeek,
      dayOfMonth,
      emailOnly: false
    };

    const dialogRef = dialog.open(RecurringDodDialogComponent, {
      disableClose: true,
      width: '750px',
      data: params,
    });

    return dialogRef.afterClosed();
  }

  static showDialogEmailOnly(
    dialog: MatDialog
  ): Observable<any> {
    const params: RecurringDodDialogData = {
      dodRecurringId: 0,
      dodBatchLayoutId: 0,
      recurringType: 0,
      dayOfWeek: 0,
      dayOfMonth: 0,
      emailOnly: true
    };

    const dialogRef = dialog.open(RecurringDodDialogComponent, {
      disableClose: true,
      width: '750px',
      data: params,
    });

    return dialogRef.afterClosed();
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultData = this.results;
    this.Result.ResultType = DialogResultType.Ok;
    this.dialogRef.close(this.Result);
  }
}
